import { Platform, StyleSheet } from 'react-native';
import Constants from 'expo-constants';

const VERSION = Constants.expoConfig.version;
const MAJOR_VERSION_NUMBER = Constants.expoConfig.extra.majorVersion;
const MINOR_VERSION_NUMBER = Constants.expoConfig.extra.minorVersion;
const PATCH_VERSION_NUMBER = Constants.expoConfig.extra.patchVersion;

const IS_DEVELOPMENT = false;
const DEFAULT_DEBUG_LEVEL = false;

const HOST = "rabbl.com";
const LARGE_HOURGLASS_SIZE = 125;

// https://support.google.com/analytics/answer/1033863
const UTM_SOURCES = Object.freeze({
  RABBL: "rabbl",
});

// The advertising or marketing medium
const UTM_MEDIUMS = Object.freeze({
  REFERRAL: "referral",
  AFFILIATE: "affiliate",
  CPC: "cpc",
  BANNER: "banner",
  EMAIL: "email",
  NEWSLETTER: "newsletter",
  SOCIAL: "social",
});

const UTM_CAMPAIGNS = Object.freeze({
  GENERAL: "general",
});

const DEFAULT_FONT = 'sans-serif';

const BASIC_PADDING_HORIZONTAL = 30;

const STYLES = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  flex1Center: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flexRow: {
    flexDirection: 'row',
  },
  flexRowGap5: {
    flexDirection: 'row',
    gap: 5,
  },
  flexRowGap10: {
    flexDirection: 'row',
    gap: 10,
  },
  flexRowGap20: {
    flexDirection: 'row',
    gap: 20,
  },
  scrollView: {
    backgroundColor: 'transparent',
  },
  basicView: {
    backgroundColor: 'transparent',
    gap: 20,
  },
  basicScrollView: {
    marginHorizontal: BASIC_PADDING_HORIZONTAL,
    marginVertical: 10,
    marginTop: 0,
    backgroundColor: 'transparent',
    gap: 20,
    flexGrow: 1,
  },
  basicScrollViewCenter: {
    marginHorizontal: BASIC_PADDING_HORIZONTAL,
    marginVertical: 10,
    marginTop: 0,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
    flexGrow: 1,
  },
  basicWrapperView: {
    marginHorizontal: BASIC_PADDING_HORIZONTAL,
    marginVertical: 10,
    marginTop: 0,
    backgroundColor: 'transparent',
    gap: 20,
    flex: 1,
  },
  basicWrapperViewCenter: {
    marginHorizontal: BASIC_PADDING_HORIZONTAL,
    marginVertical: 10,
    marginTop: 0,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
    flex: 1,
  },
  basicViewCenter: {
    marginHorizontal: BASIC_PADDING_HORIZONTAL,
    marginVertical: 10,
    marginTop: 0,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
    flexGrow: 1,
  },
  noHorizontalMargin: {
    marginHorizontal: 0,
  },
  image18x18: {
    width: 18,
    height: 18,
  },
  image24x24: {
    width: 24,
    height: 24,
  },
  image25x25: {
    width: 25,
    height: 25,
  },
  image30x30: {
    width: 30,
    height: 30,
  },
  margin10: {
    margin: 10,
  },
  marginBottom10: {
    marginBottom: 10,
  },
  marginBottom20: {
    marginBottom: 20,
  },
  marginVertical10: {
    marginVertical: 10,
  },
  marginVertical20: {
    marginVertical: 20,
  },
  marginTop5: {
    marginTop: 5,
  },
  marginTop10: {
    marginTop: 10,
  },
  marginTop15: {
    marginTop: 15,
  },
  marginTop20: {
    marginTop: 20,
  },
  gap20: {
    gap: 20,
  },
  gap20alignCenter: {
    gap: 20,
    alignItems: "center",
  },
  padding1: {
    padding: 1,
  },
  padding2: {
    padding: 2,
  },
  padding3: {
    padding: 3,
  },
  padding4: {
    padding: 4,
  },
  padding5: {
    padding: 5,
  },
  padding10: {
    padding: 10,
  },
  padding15: {
    padding: 15,
  },
  padding20: {
    padding: 20,
  },
  padding20gap20: {
    padding: 20,
    gap: 20,
  },
  padding20gap20center: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  padding20gap10center: {
    padding: 20,
    gap: 10,
    alignItems: 'center',
  },
  padding20top0: {
    padding: 20,
    paddingTop: 0,
  },
  paddingTop10Bottom15: {
    paddingTop: 10,
    paddingBottom: 15,
  },
  paddingVertical10: {
    paddingVertical: 10,
  },
  paddingVertical10Left10: {
    paddingVertical: 10,
    paddingLeft: 10,
  },
  paddingVertical10Right10: {
    paddingVertical: 10,
    paddingRight: 10,
  },
  paddingRight10: {
    paddingRight: 10,
  },
  paddingLeft10: {
    paddingLeft: 10,
  },
  paddingHorizontal10: {
    paddingHorizontal: 10,
  },
  fontSize17: {
    fontSize: 17,
  },
  fontBold: {
    fontWeight: 'bold',
  },
  fontBoldColorRed: {
    fontWeight: "bold",
    color: "red",
  },
  backgroundWhite: {
    backgroundColor: "#ffffff",
  },
  width100P: {
    width: '100%',
  },
  width100PAlignCenter: {
    width: '100%',
    alignItems: "center",
  },
  width100PmarginVertical10borderNone: {
    width: "100%",
    marginVertical: 10,
    borderColor: 'none',
  },
  horizontal1: {
    flexDirection: 'row',
    gap: 20,
  },
  horizontal1Wrap: {
    flexDirection: 'row',
    gap: 20,
    flexWrap: 'wrap',
  },
  width100PmarginVertical10borderNoneMinHeight: {
    width: "100%",
    marginVertical: 10,
    borderColor: 'none',
    ...Platform.select({
      ios: {
        minHeight: 20 * 5
      },
    })
  },
  width100PmarginVertical10border1: {
    width: "100%",
    marginVertical: 10,
    borderWidth: 1,
    padding: 10,
    borderColor: '#000000',
  },
  snackWrapper: {
    alignSelf: "center",
    zIndex: 1,
    width: 326,
  },
  centeredButton: {
    flexDirection: "row",
    alignSelf: "center",
  },
  centeredRow: {
    flexDirection: "row",
    alignSelf: "center",
  },
  link: {
    color: "#0000EE",
    textDecorationLine: "underline",
  },
  container1: {
    flex: 1,
    gap: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  container2: {
    flex: 1,
    gap: 20,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  heading1: {
    fontSize: 35,
    fontWeight: 'bold',
  },
  subheading1: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  alignCenter: {
    alignItems: 'center',
  },
  alignCenterGap10: {
    alignItems: 'center',
    gap: 10,
  },
  alignCenterGap20: {
    alignItems: 'center',
    gap: 20,
  },
  defaultFont: {
    fontFamily: DEFAULT_FONT,
  },
  textInputMultiline: {
    minHeight: 150,
    textAlignVertical: 'top',
    minWidth: "50%",
  },
  hoveringButtonRight: {
    position: "absolute",
    right: 10,
    zIndex: 10,
    elevation: (Platform.OS === 'android') ? 10 : 0,
  },
  fontSmall: {
    fontSize: 12,
  },
  monospace: {
    // https://stackoverflow.com/questions/38781089/font-family-monospace-monospace
    fontFamily: Platform.OS === "web" ? "monospace, monospace" : "VT323-Regular",
  },
  passwordInputRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 15,
  },
  imageKey: {
    width: 32,
    height: 32,
  },
  imageKeySmall: {
    width: 15,
    height: 32,
  },
  imageInfoSmall: {
    width: 16,
    height: 16,
    opacity: 0.4,
  },
  brandIcon: {
    width: 32,
    height: 32,
  },
});

const LOCAL_DATA_KEYS = Object.freeze({
  REMOTE_SESSION: "remoteSession",
  SAVED_APP_STATE: "savedAppState",
  USED_APP_BEFORE: "usedAppBefore",
  DOMAIN: "domain",
});

// https://developers.google.com/maps/documentation/javascript/overview
// https://developers.google.com/maps/documentation/javascript/react-map
// https://developers.google.com/maps/documentation/javascript/adding-a-google-map
// https://developers.google.com/maps/documentation/javascript/overview#MapOptions
// https://developers.google.com/maps/documentation/javascript/reference
// https://developers.google.com/maps/documentation/javascript/reference/map#Map
const ZOOM_LEVELS = Object.freeze({
  WORLD: 1,
  CONTINENT: 5,
  COUNTRY: 6,
  STATE: 7,
  CITY: 10,
  STREETS: 15,
  BUILDINGS: 20,
});

// In the middle of the "United States" text of Google Maps
const CENTER_UNITED_STATES = {
  lat: 39.837917118760664,
  lng: -101.47794131398716,
};

// https://developers.google.com/maps/documentation/javascript/style-reference#style-features
// https://developers.google.com/maps/documentation/javascript/style-reference#style-elements
// https://developers.google.com/maps/documentation/javascript/style-reference#stylers
const MAP_FEATURES = [
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  /*
  // This removes suburb names but also removes city names:
  {
    featureType: "administrative.locality",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  */
];

export {
  HOST,
  VERSION,
  MAJOR_VERSION_NUMBER,
  MINOR_VERSION_NUMBER,
  PATCH_VERSION_NUMBER,
  IS_DEVELOPMENT,
  DEFAULT_DEBUG_LEVEL,
  STYLES,
  LOCAL_DATA_KEYS,
  UTM_SOURCES,
  UTM_MEDIUMS,
  UTM_CAMPAIGNS,
  LARGE_HOURGLASS_SIZE,
  DEFAULT_FONT,
  BASIC_PADDING_HORIZONTAL,
  ZOOM_LEVELS,
  CENTER_UNITED_STATES,
  MAP_FEATURES,
}
